import { isAnyAdmin, isEmployee } from 'permissions/v1/roles';
import { canList, canView, canCreate, canUpdate, canDestroy } from 'permissions/v1/index';

const permission = 'Certificate';

const list = (profile) => isAnyAdmin(profile) || canList(permission, profile);
const view = (profile) =>
  isAnyAdmin(profile) || isEmployee(profile) || canView(permission, profile);
const create = (profile) => isAnyAdmin(profile) || canCreate(permission, profile);
const update = (profile) => isAnyAdmin(profile) || canUpdate(permission, profile);
const destroy = (profile) => isAnyAdmin(profile) || canDestroy(permission, profile);
const audit = (profile) => isAnyAdmin(profile) || canUpdate(permission, profile);

const permissions = (profile) => {
  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
    audit: audit(profile),
  };
};

export default permissions;
